import { render, staticRenderFns } from "./GlobalHeaderScreen.vue?vue&type=template&id=5b687ff6&scoped=true&"
import script from "./GlobalHeaderScreen.vue?vue&type=script&lang=js&"
export * from "./GlobalHeaderScreen.vue?vue&type=script&lang=js&"
import style0 from "./GlobalHeaderScreen.vue?vue&type=style&index=0&id=5b687ff6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b687ff6",
  null
  
)

export default component.exports